import type { ByggDokument } from '../classes';

export const groupDocuments = (byggDokumentList: Array<ByggDokument>) => {
    const byggDokumentListGrouped: object = {};
    byggDokumentList.forEach((dokument: ByggDokument) => {
        const { fag } = dokument;
        if (!byggDokumentListGrouped[fag]) {
            byggDokumentListGrouped[fag] = [];
        }
        byggDokumentListGrouped[fag].push(dokument);
    });
    return byggDokumentListGrouped;
};
